export default __webpack_public_path__ + "f5769c0a4561d35695543c76f0e0aa3c.jpg";